/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exercise_Personal_Strength_Missing_Date_Of_BirthInputs */

const en_us2_exercise_personal_strength_missing_date_of_birth = /** @type {(inputs: Exercise_Personal_Strength_Missing_Date_Of_BirthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`date of birth`)
};

const pt_br2_exercise_personal_strength_missing_date_of_birth = /** @type {(inputs: Exercise_Personal_Strength_Missing_Date_Of_BirthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`data de nascimento`)
};

const es_419_exercise_personal_strength_missing_date_of_birth = /** @type {(inputs: Exercise_Personal_Strength_Missing_Date_Of_BirthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`fecha de nacimiento`)
};

const pt_pt2_exercise_personal_strength_missing_date_of_birth = /** @type {(inputs: Exercise_Personal_Strength_Missing_Date_Of_BirthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`data de nascimento`)
};

const fr_fr2_exercise_personal_strength_missing_date_of_birth = /** @type {(inputs: Exercise_Personal_Strength_Missing_Date_Of_BirthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`date de naissance`)
};

const de_de2_exercise_personal_strength_missing_date_of_birth = /** @type {(inputs: Exercise_Personal_Strength_Missing_Date_Of_BirthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geburtsdatum`)
};

const it_it2_exercise_personal_strength_missing_date_of_birth = /** @type {(inputs: Exercise_Personal_Strength_Missing_Date_Of_BirthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`data di nascita`)
};

/**
* | output |
* | --- |
* | "date of birth" |
*
* @param {Exercise_Personal_Strength_Missing_Date_Of_BirthInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_personal_strength_missing_date_of_birth = /** @type {((inputs?: Exercise_Personal_Strength_Missing_Date_Of_BirthInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Personal_Strength_Missing_Date_Of_BirthInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_personal_strength_missing_date_of_birth(inputs)
	if (locale === "es-419") return es_419_exercise_personal_strength_missing_date_of_birth(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_personal_strength_missing_date_of_birth(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_personal_strength_missing_date_of_birth(inputs)
	if (locale === "de-DE") return de_de2_exercise_personal_strength_missing_date_of_birth(inputs)
	if (locale === "it-IT") return it_it2_exercise_personal_strength_missing_date_of_birth(inputs)
	return en_us2_exercise_personal_strength_missing_date_of_birth(inputs)
});
export { exercise_personal_strength_missing_date_of_birth as "exercise-personal.strength_missing_date_of_birth" }